import { Boitier } from '../Model/Boitier';
import { ServiceAdminService } from '../Providers/service-admin.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Headers, RequestOptions } from '@angular/http';

/**
 * created by AHMED HAYEL
 * 
 */

@Component({
  selector: 'app-admin-component',
  templateUrl: './admin-component.component.html',
  styleUrls: ['./admin-component.component.css']
})
export class AdminComponentComponent implements OnInit {
  title = 'Espace Administration';

  isActiveDashBoard: boolean = true;
  isActiveForm: boolean = false;
  isActiveList: boolean = false;

  constructor(private service: ServiceAdminService, private router: Router) { }

  ngOnInit() {

    this.service.isAuthenticated = this.service.loadTestAuthenticated();

    if (this.service.isAuthenticated == false) {
      this.router.navigate(['/error']);
    } else {

      this.service.getAllIps().subscribe(ips => {
        this.service.ips = ips;
      });
    }

  }

  //=====================================
  //    Log Out
  //=====================================

  logout() {
    window.location.pathname = "/authentification";
    this.router.navigate(['/authentification']);
    this.service.logoutStorage();
  }

  //=====================================
  //    LEFT BAR COLOR
  //=====================================



}



// WEBPACK FOOTER //
// ./src/app/admin-component/admin-component.component.ts